<template>
  <v-footer
    id="core-footer"
    absolute
    height="82"
  >
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          :target="link.target"
          class="tertiary--text footer-links"
        >{{ link.name }}</a>
      </span>
    </div>
    <v-spacer />
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="https://rextech.com.my"
        target="_blank"
      >Rex Technologies</a>
    </span>
  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      links: [
        { name: 'Home', Link: '/', target: '' },
        { name: 'About Us', Link: 'https://rextech.com.my', target: '_blank' },
      ],
    }),
  }
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
